import React, { useState, useEffect } from "react";
import OwnerServices from "../../services/externalServices/trackingservices/ownerServices";
import OwnerTable from "./OwnerTable";
import OwnerModal from "./OwnerModal";

const Owners = () => {
  const [owners, setOwners] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const [selectedOwner, setSelectedOwner] = useState(null);

  useEffect(() => {
    const fetchOwners = async () => {
      try {
        const response = await OwnerServices.getAllOwners();
        // console.log("Fetched owners:", response.data);
        setOwners(response);
      } catch (error) {
        console.error("Error fetching owners:", error);
      }
    };

    fetchOwners();
  }, []);

  const handleCreateOwner = () => {
    setSelectedOwner(null);
    // setIsModalOpen(true);
    setOpenModal(true);
  };

  const handleEditOwner = (owner) => {
    setSelectedOwner(owner);
    // setIsModalOpen(true);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    // setIsModalOpen(false);
    setOpenModal(false);
  };

  const handleSaveOwner = async (ownerData) => {
    try {
      if (selectedOwner) {
        await OwnerServices.updateOwnerById(selectedOwner._id, ownerData);
      } else {
        await OwnerServices.createOwner(ownerData);
      }
      const response = await OwnerServices.getAllOwners();
      setOwners(response);
      setOpenModal(false);
    } catch (error) {
      console.error("Error saving owner:", error);
    }
  };

  return (
    <div className="container mx-auto px-4 sm:px-8">
      <div className="py-8">
        <div>
          <h2 className="text-2xl font-semibold leading-tight">Owners</h2>
        </div>
        <div className="my-2 flex sm:flex-row flex-col">
          <div className="flex flex-row mb-1 sm:mb-0">
            <button
              onClick={handleCreateOwner}
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
            >
              Create Owner
            </button>
          </div>
        </div>
        <OwnerTable owners={owners} onEdit={handleEditOwner} />
      </div>
      {openModal && (
        <OwnerModal
          open={openModal}
          owner={selectedOwner}
          onClose={() => setOpenModal(false)}
          onSave={handleSaveOwner}
        />
      )}
    </div>
  );
};

export default Owners;
